import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";
import { V2, pickLang } from "../copy";
import { Arrow, Words } from "./Primitives";
import { route } from "../paths";

const CTAV2: React.FC = () => {
  const { currentLanguage } = useLanguage();
  const lang = pickLang(currentLanguage);
  const c = V2[lang].cta;

  return (
    <section className="relative isolate overflow-hidden bg-ink py-28 text-bone sm:py-40">
      <div className="v2-glow pointer-events-none absolute left-1/2 top-1/2 -z-10 h-[70vw] w-[70vw] -translate-x-1/2 -translate-y-1/2 rounded-full bg-tangerine/[0.10] blur-[160px]" />

      <div className="mx-auto max-w-[1400px] px-4 text-center sm:px-6">
        <h2
          data-words
          className="font-display text-[clamp(3.4rem,11vw,11rem)] leading-[0.9] tracking-[-0.03em]"
        >
          <span className="block">
            <Words text={c.title[0]} />
          </span>
          <span className="block italic text-tangerine">
            <Words text={c.title[1]} baseDelay={0.25} />
          </span>
        </h2>
        <p className="v2-reveal mx-auto mt-8 max-w-md text-bone/65" data-delay="2">
          {c.sub}
        </p>
        <div className="v2-reveal mt-10 flex flex-wrap justify-center gap-3" data-delay="3">
          <Link to={`/${lang}/signup`} className="v2-btn v2-btn-solid">
            {c.cta1}
            <Arrow />
          </Link>
          <Link to={route(lang, "devis")} className="v2-btn v2-btn-ghost">
            {c.cta2}
          </Link>
        </div>

        <div
          className="v2-reveal mx-auto mt-16 flex max-w-3xl flex-wrap items-center justify-center gap-x-10 gap-y-3 border-t border-bone/10 pt-6 font-mono text-[11px] uppercase tracking-[0.2em] text-bone/50"
          data-delay="4"
        >
          <a href={`mailto:${c.email}`} className="v2-link normal-case tracking-normal text-bone/80">
            {c.email}
          </a>
          <span>{c.hours}</span>
          <span>{c.city}</span>
        </div>
      </div>
    </section>
  );
};

export default CTAV2;
